import { render, staticRenderFns } from "./SettingEmail.vue?vue&type=template&id=7fc7d0ae"
import script from "./SettingEmail.vue?vue&type=script&lang=js"
export * from "./SettingEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports